export const text = {
  title: 'Welcome Back',
  subtitle: 'Sign in to your account',
  submit: 'Sign In',
  signUpPrompt: "Don't have an account? ",
  signUpAction: 'Sign up',
  forgotPassword: 'Forgot password?',
  success: 'Signed in successfully!',
  invalidPassword: 'Invalid password. Please try again.',
  error: 'Could not sign in, did you mean to sign up?',
};
